var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoComcolors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 294.8 59"
    },
    viewBox: "0 0 294.8 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M154.3 46.9c-2 3.5-6.8 7.1-13.1 7.1-8.6 0-15.6-6.5-15.6-15.6s7-15.6 15.6-15.6c6.4 0 11 3.8 13.2 7.2H153c-1.1-1.6-5.1-6.1-11.7-6.1-8 0-14.4 6.1-14.4 14.5 0 8.3 6.4 14.5 14.4 14.5 7 0 10.9-4.8 11.7-6h1.3zM155.5 38.4c0-9 7-15.5 15.6-15.5s15.6 6.5 15.6 15.6-7 15.6-15.6 15.6c-8.6-.1-15.6-6.7-15.6-15.7zm1.2.1c0 8.3 6.4 14.4 14.4 14.4s14.4-6.1 14.4-14.5c0-8.3-6.4-14.5-14.4-14.5s-14.4 6.2-14.4 14.6zM189.5 23.4h1.2v29h12.7v1.1h-13.9V23.4zM200.8 38.4c0-9 7-15.5 15.6-15.5S232 29.4 232 38.5 225 54 216.4 54s-15.6-6.6-15.6-15.6zm1.2.1c0 8.3 6.4 14.4 14.4 14.4s14.4-6.1 14.4-14.5c0-8.3-6.4-14.5-14.4-14.5S202 30.1 202 38.5zM234.4 23.4h6.9c4.7 0 6.5.4 8 1.3 2.4 1.2 4.3 4.5 4.3 8 .1 1.9-.5 4.2-1.9 6.1-2.2 2.9-4.7 3.3-8.1 3.4l8.1 11.3h-1.5L241.3 41h.9c2.2 0 5.8 0 7.7-1.9 1.9-2 2.6-4.1 2.6-6.4 0-2.6-1.3-5.5-3.6-7-1.8-1.2-4-1.2-7.6-1.2h-5.6v29h-1.2V23.4zM258 45.9c.9 5.8 6.4 7 9.3 7 4.7 0 9.5-2.8 9.5-7.2 0-5.5-6-6.7-9.6-7.4-3.3-.7-9.9-1.9-9.9-7.6-.2-5 4.8-7.8 10.2-7.8 4.4 0 8.9 2.1 9.7 7h-1.5c-.6-2.4-2.2-5.9-8.3-5.9-4.8 0-8.6 2.6-8.6 6.5-.1 4.8 4.9 6 10.1 7 1.8.4 9.3 1.5 9.3 8 0 5-5.3 8.4-10.9 8.4-4.5 0-10.4-2.4-10.9-8.1h1.6z",
    style: {
      fill: "#929395"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1 31.4c-.3.3-.5 1.1-.8 1.6-.3.8-.6 1-.9 2.4.7-.3 1.6-1.1 2-1.7 4.4-2.9 5-4.2 8.4-4.3 1.3.5 1.9 1.7 2.1 3.5.8.9.5 3.9 2.5 3.7 3.5-.5 11.8-9 11.7-6.2 0 .4-1.2 2.4-5.9 6.2-.7.5-2.9 2.1-4.7 3.2-.4.2-2 1.4-4.2 1.5-1 0-2.6-.8-2.9-1.3-1.2-.8-1.7-4.1-4.5-4-4.5 2.4-5.1 4-5.9 4.4-.6 1-1.4 1.2-2.8 2.5-2.5 2.3-3.2 3.1-5.3 3.2-.2-.4-.7-.8-.7-1 .2-.9 2.6-5.1 2.9-5.9.6-.5 1.7-3.9 2.5-5.5.2-.7 0-.9-.5-.8-1.7.1-2.6 1.8-4.8 2.9-3.4 3.4-5.2 4.2-8.1 7.3-.7 0-2.6 2.8-4 2.9-1.2.1-1.6-.6-1.5-.9.5-2 4.4-8.3 4.7-9.4.1-.3-.1-.6-.3-.6-2 .1-11.3 7.8-12.9 7.9.3-1.5.5-2.6.7-3.5.3-1.1 12.1-7.8 12.9-9 .5-.1 3.7-3.2 4.7-3.5.4-.4 1.7-1.1 2.7-1.2 1.4-.1 1.7.3 1.4 1.7-.3 1.3-.6 2.5-1.4 3.5-.3 1.4-.9 1.9-1.1 2.6-.2.2-.1.4.1.4s1.1-.5 1.5-1c.7-.1 4.7-4 6.5-5.2 3.6-2.8 4.7-3.9 6.5-3.9 1 0 1.3.4 1.1 2.5-.1.4-1.2 2.9-1.7 5zM18.6 52.4c16.3 1.9 28.5-6.9 29.6-6.8.5.1.7.7.5 1.5-.7 2.1-21.3 10.8-35.2 9.2-5.2-.7-15.6-5.4-11.6-19.5C7.9 15.6 35.2-.7 51.4 1.2c3.3.4 7.4 1.8 7.6 7.9 0 .8.1 2.2-.7 2.4-.7.2-1-.5-1.3-1.4-.9-2.5-3.6-3.8-8.9-4.5C28.8 3.3 10 22.8 7.6 37.4c-1.6 10.2 3.9 14.1 11 15z",
    style: {
      fill: "#3e3d40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6 38c0 9.3-7.5 16.8-16.8 16.8S43 47.3 43 38s7.5-16.8 16.8-16.8S76.6 28.7 76.6 38z",
    style: {
      fill: "#006ab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4 38.4c-.4 9.4-8 16.8-17.7 15.2-7.8-1.3-13.5-8.2-13.5-16 0-9.6 8.7-16.9 18.3-14.9 7.8 1.6 12.6 8.3 12.9 16 0 1.1 2.4-.2 2.3-1.2-.4-10.6-9.6-18.7-20.3-17-8.7 1.4-15.6 9.2-15.6 18.1 0 10.1 8.9 18.1 18.9 17.3 9.5-.8 16.6-8.8 17-18.1.1-1.5-2.2-.4-2.3.6z",
    style: {
      fill: "#3e3d40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 27.1 59.8 38l6.3-10.9c-3.8-2.2-8.6-2.3-12.6 0z",
    style: {
      fill: "#358e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1 27.4c2.1 3.6 4.2 7.3 6.3 10.9.1.2.6-.1.7-.2 2.1-3.6 4.2-7.3 6.3-10.9.1-.1.1-.3 0-.4-4.2-2.2-8.8-2.2-13 0-.4.2-.4.8.2.6 2.2-1.2 4.5-1.8 6.9-1.6.8.1 1.6.2 2.4.4-.3-.1 2.9 1 2.9.9.1.5-1.6 2.7-1.8 3.1L59.5 38c.2-.1.4-.1.7-.2-2.1-3.6-4.2-7.3-6.3-10.9-.2-.4-.9.1-.8.5z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 48.9 59.8 38l6.3 10.9c-3.8 2.2-8.6 2.3-12.6 0z",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 48.9c2.1-3.6 4.2-7.3 6.3-10.9-.2.1-.4.1-.7.2 2.1 3.6 4.2 7.3 6.3 10.9.1-.2.2-.4.3-.5-4 2.1-8.3 2.1-12.2 0-.3-.2-.9.4-.6.6 4.2 2.2 8.8 2.2 13 0 .2-.1.4-.3.3-.5-2.1-3.6-4.2-7.3-6.3-10.9-.1-.2-.6.1-.7.2-2.1 3.6-4.2 7.3-6.3 10.9-.3.5.4.4.6 0z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 38h12.6l-6.3-10.9c-3.8 2.2-6.3 6.2-6.3 10.9z",
    style: {
      fill: "#006ab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1 38.3h12.6c.2 0 .6-.3.5-.6-2.1-3.6-4.2-7.3-6.3-10.9-.1-.1-.3-.1-.4 0-4.1 2.5-6.5 6.5-6.6 11.3 0 .5.8.1.8-.2.1-2 .4-3.8 1.4-5.6.7-1.4 2.3-4 3.9-4.5.7-.2.4-.2.9.6.4.7.8 1.3 1.1 2 1.5 2.6 3.1 5.3 4.6 7.9.2-.2.3-.4.5-.6H47.5c-.5 0-1 .6-.4.6z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1 48.9 59.8 38h12.6c0 4.3-2.3 8.6-6.3 10.9z",
    style: {
      fill: "#f29400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4 48.6c-2.1-3.6-4.2-7.3-6.3-10.9-.2.2-.3.4-.5.6h9.2c.5 0 3.1-.3 3.4 0 0 0-.4 1.7-.4 1.9-.2.9-.4 1.8-.8 2.7-1 2.4-2.8 4.3-5 5.7-.4.2-.4.9.1.6 4.1-2.5 6.5-6.5 6.6-11.3 0-.2-.1-.2-.2-.2H59.9c-.2 0-.6.3-.5.6 2.1 3.6 4.2 7.3 6.3 10.9.2.3.9-.2.7-.6z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 48.9 59.8 38H47.2c0 4.3 2.3 8.6 6.3 10.9z",
    style: {
      fill: "#a663a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 48.9c2.1-3.6 4.2-7.3 6.3-10.9.1-.2.1-.4-.2-.4H47.3c-.2 0-.5.2-.5.5.1 4.7 2.4 8.6 6.4 11.1.3.2.9-.4.6-.6-2.7-1.7-4.8-4.1-5.7-7.2-.2-.6-.8-3-.8-3 .2-.1 1 0 1.2 0h9.9c.4 0 .8-.1 1.2 0-.3-.1.2-.6-.3 0-.8 1-1.4 2.4-2 3.5-1.3 2.3-2.7 4.6-4 6.9-.4.6.3.5.5.1z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4 38H59.8l6.3-10.9c3.8 2.2 6.3 6.2 6.3 10.9z",
    style: {
      fill: "#fcc51d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 37.7H62.1c-.3 0-2.2-.1-2 .2.2.3.9-1.2 1.1-1.5.7-1.2 1.4-2.5 2.2-3.7 1-1.8 2.1-3.6 3.1-5.5l-.6.3c3.8 2.4 6.1 6.2 6.2 10.7 0 .5.8.1.8-.2-.1-4.7-2.4-8.6-6.4-11.1-.2-.1-.5.1-.6.3-2.1 3.6-4.2 7.3-6.3 10.9-.1.2-.1.4.2.4h12.6c.2-.2.7-.8.1-.8z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 38c0 2.8-2.3 5-5 5-2.8 0-5-2.3-5-5 0-2.8 2.3-5 5-5 2.8 0 5 2.2 5 5z",
    style: {
      fill: "#006ab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4 38.1c-.3 6.2-9.4 5.7-9.3-.3 0-3.1 3-5.2 5.9-4.3 2.2.8 3.3 2.6 3.4 4.6 0 .4.8 0 .8-.3-.4-7-10.8-6.4-10.8.4 0 3.1 2.8 5.5 5.8 5.2 2.8-.3 4.9-2.7 5-5.5 0-.5-.7-.1-.8.2z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.2 23.3c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5-4.5-2-4.5-4.5 2-4.5 4.5-4.5zm0 8.5c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.7 4 4 4zm-1.8-6.7h2c1 0 1.7.3 1.7 1.5 0 .9-.5 1.3-1.4 1.4l1.6 2.4h-.6l-1.6-2.4h-1.4v2.4h-.5v-5.3zm.5 2.5h1.1c1 0 1.7-.1 1.7-1 0-.8-.5-1.1-1.2-1.1h-1.6v2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoComcolors);
export default __webpack_public_path__ + "static/media/logo-comcolors.d0ca07e948da498958a28a2d8c9d2f95.svg";
export { ForwardRef as ReactComponent };